import { _lt } from '../localization/locale';

export const educationLevels = [
  _lt('Not studying'),
  _lt('School'),
  _lt('Bachelors'),
  _lt('Masters'),
  _lt('PhD'),
  _lt('Post Doc'),
];
export const enrollmentLevels = [
  _lt('Elementary School'),
  _lt('Middle School'),
  _lt('High School'),
  _lt('University'),
  _lt('Not in School'),
];
export const highestRepLevels = [
  _lt('Regional'),
  _lt('National'),
  _lt('International'),
];
export const refrenceTypes = [
  _lt('Teacher'),
  _lt('Coach'),
  _lt('Manager'),
  _lt('Teammate'),
].sort();
export const relations = [
  _lt('Teacher'),
  _lt('Coach'),
  _lt('Parent'),
  _lt('Guardian'),
].sort();
export const mediaTypes = [_lt('weburl'), _lt('audio'), _lt('video')].sort();
export const universityTests = [
  'SAT',
  'ACT',
  'GED',
  'PIL',
  'SweSAT',
  'EMS',
  'BAC',
  'Abitur',
  'MAT',
  'LNAT',
  'STEP',
  'ELAT',
  'THEA',
  'GAMSAT',
  'LSAT',
  'MAT',
  'GRE',
  'GMAT',
  'MCAT',
  'LSAT',
  'PCAT',
  'DAT',
  'USE',
  'CE',
  'PSU',
  'ICFES',
  'ENEM',
  'ATAR',
  'STAT',
  'HKDSE',
  'NCTUA',
  'EJU',
  'STPM',
  'ENES',
  'YGS-LYS',
  'ZNO',
  'Matura',
  'DME',
  'HHX',
  'HTX',
  'HF',
  'LCE',
].sort();

export const siteRoles = [
  { name: _lt('Athlete - Minor'), value: 1 },
  { name: _lt('Athlete'), value: 2 },
  { name: _lt('Guardian'), value: 3 },
  { name: _lt('Coach'), value: 4 },
  { name: _lt('Team Owner/Admin'), value: 5 },
  { name: _lt('Club Owner/Admin'), value: 6 },
  { name: _lt('Scout'), value: 7 },
  { name: _lt('Agent'), value: 8 },
];

export const socialMediaSites = [
  _lt('Facebook'),
  _lt('Google'),
  _lt('Instagram'),
  _lt('LinkedIn'),
  _lt('Twitter'),
  _lt('Vimeo'),
  _lt('Youtube'),
];

export const sports = [];
